__turbopack_context__.v({
  "coverEyebrow": "BlockDeckSlider-module-scss-module__d9kazG__coverEyebrow",
  "coverImage": "BlockDeckSlider-module-scss-module__d9kazG__coverImage",
  "ctaButton": "BlockDeckSlider-module-scss-module__d9kazG__ctaButton",
  "fade-in": "BlockDeckSlider-module-scss-module__d9kazG__fade-in",
  "root": "BlockDeckSlider-module-scss-module__d9kazG__root",
  "slide": "BlockDeckSlider-module-scss-module__d9kazG__slide",
  "slideContent": "BlockDeckSlider-module-scss-module__d9kazG__slideContent",
  "slideContentCover": "BlockDeckSlider-module-scss-module__d9kazG__slideContentCover",
  "slideContentInner": "BlockDeckSlider-module-scss-module__d9kazG__slideContentInner",
  "slideContentSlides": "BlockDeckSlider-module-scss-module__d9kazG__slideContentSlides",
  "slideHeading": "BlockDeckSlider-module-scss-module__d9kazG__slideHeading",
  "slideIcon": "BlockDeckSlider-module-scss-module__d9kazG__slideIcon",
  "slideIconContainer": "BlockDeckSlider-module-scss-module__d9kazG__slideIconContainer",
  "slideTab": "BlockDeckSlider-module-scss-module__d9kazG__slideTab",
  "slideTabText": "BlockDeckSlider-module-scss-module__d9kazG__slideTabText",
  "slide__active": "BlockDeckSlider-module-scss-module__d9kazG__slide__active",
  "slide__current": "BlockDeckSlider-module-scss-module__d9kazG__slide__current",
  "slide__hover": "BlockDeckSlider-module-scss-module__d9kazG__slide__hover",
  "slides": "BlockDeckSlider-module-scss-module__d9kazG__slides",
  "steps": "BlockDeckSlider-module-scss-module__d9kazG__steps",
  "theme--makers-reserve": "BlockDeckSlider-module-scss-module__d9kazG__theme--makers-reserve",
  "touchCta": "BlockDeckSlider-module-scss-module__d9kazG__touchCta",
});
